import { computed, ref } from '@vue/composition-api'
import snakeCaseToCamelCase from '@/utils/snake-case-to-camcel-caase'
import notesCategories from './notes-categories'

export default function useEditNote(props, ctx) {
  const submitBtnLoading = ref(false)
  const showEditSection = ref(false)
  const noteData = ref({ ...props.note, category: props.note.category && snakeCaseToCamelCase(props.note.category) })
  const userId = ctx.root.$route.params.id
  const loggedUser = computed(() => ctx.root.$store.getters['auth/getLoggedUser'])
  const editNote = async () => {
    try {
      submitBtnLoading.value = true
      showEditSection.value = true
      await ctx.root.$store.dispatch('notes/editNote', {
        notableType: props.notableType,
        notableId: userId,
        note: noteData.value.note,
        noteId: noteData.value.id,
        category: noteData.value.category,
        addedBy: loggedUser.value.email,
      })
      ctx.emit('editedNote')
    } catch (error) {
      console.log(error)
    } finally {
      submitBtnLoading.value = false
      showEditSection.value = false
    }
  }

  return {
    editNote,
    loggedUser,
    submitBtnLoading,
    showEditSection,
    noteData,
    notesCategories,
  }
}
